
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"16","viewBox":"0 0 14 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5631 2.30263H10.288V1.75987C10.288 0.789474 9.51133 0 8.55663 0H5.44337C4.48867 0 3.71197 0.789474 3.71197 1.75987V2.30263H0.436893C0.194175 2.30263 0 2.5 0 2.74671C0 2.99342 0.194175 3.19079 0.436893 3.19079H1.22654V13.625C1.22654 14.9342 2.27508 16 3.56311 16H10.4369C11.7249 16 12.7735 14.9342 12.7735 13.625V3.19079H13.5631C13.8058 3.19079 14 2.99342 14 2.74671C14 2.5 13.8058 2.30263 13.5631 2.30263ZM4.58576 1.75987C4.58576 1.27961 4.97087 0.888158 5.44337 0.888158H8.55663C9.02913 0.888158 9.41424 1.27961 9.41424 1.75987V2.30263H4.58576V1.75987ZM11.8997 13.625C11.8997 14.4441 11.2427 15.1118 10.4369 15.1118H3.56311C2.75728 15.1118 2.10032 14.4441 2.10032 13.625V3.19079H11.9029V13.625H11.8997Z","fill":"#9C9FAA"}})])
          )
        }
      }
    